import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import IncidentTile from '../IncidentTile';
import useAsideStyles from './useAsideStyles';
import { SButtonMenu } from '../common';
import { useDispatch, useSelector } from 'react-redux';
import { setTopIncident, fetchDashboardDetails } from '@application/redux/dashboard/dashboard-slice';
import { extractTime, formatDMY } from '@application/utilities/date-time-formater';
import IncidentPreviewDrawer from '@ui/pages/Incidents/components/IncidentPreviewDrawer';
import { fetchPreviewIncident } from '@application/redux/Incidents/incident-slice';
const Aside = ({ title, data = [] }) => {
    const { containerStyles, headerStyles, listContainerStyles } = useAsideStyles();
    // const [selectedIncidentId, setSelectedIncidentId] = useState<string | null>(null);
    const handleCloseIncidentPreviewDrawer = () => {
        setShowIncidentPreviewDrawer(false);
    };
    const { topIncident } = useSelector((state) => state.dashboardSlice);
    const handleOpenIncidentPreviewDrawer = (rowId) => {
        dispatch(fetchPreviewIncident(rowId));
        setShowIncidentPreviewDrawer(true);
    };
    const dispatch = useDispatch();
    const [showIncidentPreviewDrawer, setShowIncidentPreviewDrawer] = useState(false);
    const timeOptions = [
        { name: '24Hrs', value: '24Hrs' },
        { name: 'Week', value: 'Week' },
        { name: 'Month', value: 'Month' }
    ];
    return (_jsxs(Box, { className: 'right-section-container', sx: containerStyles, children: [_jsxs(Box, { className: 'header', sx: headerStyles, children: [_jsx(Typography, { variant: 'subtitle1', color: 'textPrimary', children: title }), _jsx(SButtonMenu, { label: 'Last:', value: topIncident, options: timeOptions, size: 'small', handleChange: (opt) => {
                            dispatch(setTopIncident(opt));
                            dispatch(fetchDashboardDetails());
                        } })] }), _jsx(Box, { className: 'top-incidents-list', sx: listContainerStyles, children: data.map((item, index) => (_jsx(IncidentTile, { onTileClick: () => {
                        handleOpenIncidentPreviewDrawer(item.id);
                    }, onArrowClick: () => { }, index: index + 1, title: item.licensePlate, date: formatDMY(item.incidentDate), time: extractTime(item.incidentDate), incidentCount: item.score, imgSrc: item.imageUrl, showImagePreviewIcon: false }))) }), showIncidentPreviewDrawer && (_jsx(IncidentPreviewDrawer, { open: showIncidentPreviewDrawer, onClose: handleCloseIncidentPreviewDrawer }))] }));
};
export default Aside;
